import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.title',
    defaultMessage: 'Simulated',
  },
  deliver: {
    id: 'simulated.deliver',
    defaultMessage: 'Application date',
  },
  edit: {
    id: 'simulated.edit',
    defaultMessage: 'Edit',
  },
  studentsSingle: {
    id: 'simulated.studentsSingle',
    defaultMessage: 'Registered student',
  },
  studentsPlural: {
    id: 'simulated.studentsPlural',
    defaultMessage: 'Registered students',
  },
  replyCardsAttachedPlural: {
    id: 'simulated.replyCardsAttachedPlural',
    defaultMessage: 'reply cards attached',
  },
  replyCardsAttachedSingle: {
    id: 'simulated.replyCardsAttachedSingle',
    defaultMessage: 'reply card attached',
  },
  status_1: {
    id: 'simulated.status_1',
    defaultMessage: '1',
  },
  application_bimonthly: {
    id: 'simulated.application.bimonthly',
    defaultMessage: 'Bimonthly',
  },
  application: {
    id: 'simulated.application',
    defaultMessage: 'Application',
  },
  questionAprovation: {
    id: 'simulated.questionAprovation',
    defaultMessage: 'Approval of issues',
  },
  completed: {
    id: 'simulated.completed',
    defaultMessage: 'Completed',
  },
  questionNoDate: {
    id: 'simulated.questionNoDate',
    defaultMessage: 'No date',
  },
  to: {
    id: 'simulated.to',
    defaultMessage: 'to',
  },
  status: {
    id: 'simulated.status',
    defaultMessage: 'Status',
  },
  noCardsFound: {
    id: 'simulated.noCardsFound',
    defaultMessage: 'No cards found for the selected year',
  },
  testAnsweredSingle: {
    id: 'simulated.testAnsweredSingle',
    defaultMessage: 'answered test',
  },
  testAnsweredPlural: {
    id: 'simulated.testAnsweredPlural',
    defaultMessage: 'answered tests',
  },
  printed: {
    id: 'simulated.printed',
    defaultMessage: 'Printed',
  },
  online: {
    id: 'simulated.online',
    defaultMessage: 'Online',
  },
  printedPlusWriting: {
    id: 'simulated.printedPlusWriting',
    defaultMessage: 'Printed + Writing',
  },
  onlinePlusWriting: {
    id: 'simulated.onlinePlusWriting',
    defaultMessage: 'Online + Writing',
  },
  evaluationLevelNotebook: {
    id: 'simulated.evaluationLevelNotebook',
    defaultMessage: 'Assessment/Level/Notebook',
  },
});
